import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as feather from 'feather-icons';
import { LiveChatService } from './services/live-chat.service';
import { RecaptchaService } from './services/recaptcha.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements
OnInit, AfterViewInit {
  constructor(
    private liveChatService: LiveChatService,
    private recaptchaService: RecaptchaService
  ) { }

  ngOnInit(): void {
    this.liveChatService.initialize();
    this.recaptchaService.loadScript();
  }
  ngAfterViewInit() {
    feather.replace();
  }
}
